import React from 'react';
import PropTypes from 'prop-types';
import colors from 'theme/_colors.scss';

const IconNextPage = ({ color = colors.deionizerBlack, width = 16, height = 16, viewBox = '0 0 16 16' }) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox={viewBox} fill='none'>
            <path d='M9.5 2.5L15 8L9.5 13.5L8 12L12 8L8 4L9.5 2.5ZM2.5 2.5L8 8L2.5 13.5L1 12L5 8L1 4L2.5 2.5Z' fill={color} />
        </svg>
    );

};

IconNextPage.propTypes = {
    color: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string
};

export default IconNextPage;
